/**
 * Angular imports.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

/**
 * Rxjs imports.
 */
import { Observable } from 'rxjs';

/**
 * Constant imports.
 */
import { API } from '../../constants/api.constants';

/**
 * Set profile Service.
 */
@Injectable({
  providedIn: 'root'
})
export class SetprofileService {


  /**
   * Necessary instance.
   */
  constructor(private httpClient: HttpClient) { }

  /**
   * set Profile Single instance.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setProfileSingleValue(userData): Observable<any> {
    const body = { userData: userData };

    return this.httpClient.post(API.PROFILE, body);
  }

  /**
   * delete Profile instance.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deleteProfileData(userData): Observable<any> {
    const body = { userData: userData };

    return this.httpClient.post(API.PROFILE, body);
  }
}
